// extracted by mini-css-extract-plugin
export default {"secondaryInfo":"secondaryInfo--Oy0jX","strikeThrough":"strikeThrough--BzHAZ"};